export default __webpack_public_path__ + "static/media/sport-100-els.d006b36c.svg";